<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">TABLE OF CONTENTS</h1>
<p class="crt"><span class="hlink" href="#/OEBPS/tp" title="Link target outside of Sample">Title Page</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/alsoby" title="Link target outside of Sample">Also by Ellery Queen</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/ata" title="Link target outside of Sample">About the Author</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/cop" title="Link target outside of Sample">Copyright</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/fm1" title="Link target outside of Sample">Epigraph</span></p>
<p class="crt1"><a class="hlink" href="#/OEBPS/p01"><strong>PART ONE</strong></a></p>
<p class="crt"><a class="hlink" href="#/OEBPS/p01">Much Ado About Something</a></p>
<p class="crt"><a class="hlink" href="#/OEBPS/c02">La Belle Dame Sans Souci</a></p>
<p class="crt"><span class="hlink" href="#/OEBPS/c03" title="Link target outside of Sample">Design for Leaving</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/c04" title="Link target outside of Sample">And Sudden Death</span></p>
<p class="crt1"><span class="hlink" href="#/OEBPS/p02" title="Link target outside of Sample"><strong>PART TWO</strong></span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/p02" title="Link target outside of Sample">Gentleman or the Tiger?</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/c06" title="Link target outside of Sample">Thrust and Parry</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/c07" title="Link target outside of Sample">The Camel That Walked Like a Man</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/c08" title="Link target outside of Sample">The Glory That Was Rhys</span></p>
<p class="crt1"><span class="hlink" href="#/OEBPS/p03" title="Link target outside of Sample"><strong>PART THREE</strong></span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/p03" title="Link target outside of Sample">Lady of the Press</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/c10" title="Link target outside of Sample">A Star Reporter Is Born</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/c11" title="Link target outside of Sample">Cards Under the Table</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/c12" title="Link target outside of Sample">The Affairs of Anatole</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/c13" title="Link target outside of Sample">Winni the Pooh et Cetera</span></p>
<p class="crt1"><span class="hlink" href="#/OEBPS/p04" title="Link target outside of Sample"><strong>PART FOUR</strong></span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/p04" title="Link target outside of Sample">Storm over Glücke</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/c15" title="Link target outside of Sample">Earthly Discourse</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/c16" title="Link target outside of Sample">Quest for the OP</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/c17" title="Link target outside of Sample">Alarums and Discursions</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/c18" title="Link target outside of Sample">Rape of the Awning</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/c19" title="Link target outside of Sample">Blonde in the Woodpile</span></p>
<p class="crt1"><span class="hlink" href="#/OEBPS/p05" title="Link target outside of Sample"><strong>PART FIVE</strong></span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/p05" title="Link target outside of Sample">Everything But the Truth</span></p>
<p class="crt"><span class="hlink" href="#/OEBPS/c21" title="Link target outside of Sample">The Sport of King</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?ff87fcb8